// extracted by mini-css-extract-plugin
export default {"panel":"panel__2NqIR","codeWrapper":"codeWrapper__7BGvQ","copyButtonWrapper":"copyButtonWrapper__QzILe","copyButton":"copyButton__bvma6","redact":"redact__xCFCW"};